/** HUD panel showing the player's 3 attunement slots as circled icons (filled or empty). */
import Phaser from 'phaser';
import { crispCircle } from './CrispUtil';
import { Color } from './Theme';
import { SF0_X, SF0_Y } from '../utils/Constants';

const MAX_SLOTS = 3;
const PANEL_X = SF0_X + 16;
const PANEL_Y = SF0_Y + 44;
const ICON_RADIUS = 10;
const ICON_SPACING = 26;
const ICON_SIZE = 18;

/** Displays 3 attunement slots as circled icons in the in-game HUD. Empty slots show dim circles. */
export class AttunementPanel {
  private scene: Phaser.Scene;
  private objects: Phaser.GameObjects.GameObject[] = [];
  private currentTrees: string[] = [];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  /** Update the displayed selection. */
  setSelectedTrees(trees: string[]): void {
    if (this.arraysEqual(trees, this.currentTrees)) return;
    this.currentTrees = [...trees];
    this.rebuild();
  }

  private rebuild(): void {
    for (const obj of this.objects) obj.destroy();
    this.objects = [];

    for (let i = 0; i < MAX_SLOTS; i++) {
      const x = PANEL_X + ICON_RADIUS + i * ICON_SPACING;
      const y = PANEL_Y;
      const treeName = this.currentTrees[i];

      const border = crispCircle(this.scene, x, y, ICON_RADIUS + 1, Color.attuneBorder)
        .setScrollFactor(0).setDepth(900);
      this.objects.push(border);

      const bg = crispCircle(this.scene, x, y, ICON_RADIUS, Color.treeNodeLocked)
        .setScrollFactor(0).setDepth(900);
      this.objects.push(bg);

      if (treeName) {
        const icon = this.scene.add.image(x, y, 'attunement-icons', `tree-icon-${treeName}`)
          .setDisplaySize(ICON_SIZE, ICON_SIZE)
          .setOrigin(0.5)
          .setScrollFactor(0)
          .setDepth(901);
        this.objects.push(icon);
      }
    }
  }

  private arraysEqual(a: string[], b: string[]): boolean {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  /** Destroy all objects and free resources. */
  destroy(): void {
    for (const obj of this.objects) obj.destroy();
    this.objects = [];
  }
}
